import React, { Component } from 'react';
import PropTypes from 'prop-types';

import css from '../../styles/stocks/filter';

export default class FilterButton extends Component {
    static propTypes = {
        options: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
        defaultValue: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selected: this.props.defaultValue,
        };

        this._onChange = e => {
            const { value } = e.target;

            this.setState({ selected: value });

            this.props.onClick(value);
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.options !== nextProps.options) {
            this.setState({ selected: nextProps.defaultValue });
        }
    }

    render() {
        const { options, title, icon } = this.props;

        return (
            <div className={css.button}>
                <span className={css.icon}>{icon}</span>
                <span className={css.title}>{title}</span>
                <div className={css.selectWrapper}>
                    <select
                        ref={node => {this.select = node;}}
                        onChange={this._onChange}
                    >
                        {options.map((option, i) =>
                            <option key={i} value={option.id}>{option.name}</option>
                        )}
                    </select>
                </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/stocks/FilterButton.js
 **/